export class TripsApi {
    constructor(settings) {
        /**
         * All supported vehicle types, and their id in the Database
         */
        this.vehicles = [
            {
                id: 0,
                name: "Unkown",
                logo: "unkown",
                key: "none"
            },
            {
                id: 1,
                name: "Car",
                logo: "car",
                key: "car"
            },
            {
                id: 2,
                name: "Bicycle",
                logo: "bicycle",
                key: "bicycle"
            },
            {
                id: 3,
                name: "",
                logo: "",
                key: "car"
            },
            {
                id: 4,
                name: "Pedestrian",
                logo: "pedestrian",
                key: "pedestrian"
            },
        ];
        this.url = settings.url;
        this.key = settings.key;
    }
    /**
     * Returns the URL for the model mvt JSON.
     * @param model The model data.
     * @returns The URL.
     */
    MvtJsonUrlForModelId(modelGlobalId) {
        return this.url + `models/${modelGlobalId}/tiles/mvt.json`;
    }
    /**
     * Gets details about a single model.
     *
     * @param options The model id.
     * @returns Details about the model.
     */
    async getModel(options) {
        const url = `${this.url}models/${options.modelGlobalId}/?apiKey=${this.key}`;
        const response = await fetch(url, {
            signal: options.signal
        });
        return await response.json();
    }
    async getModelLocation(options) {
        const url = `${this.url}models/${options.modelGlobalId}/locations/${options.id}?apiKey=${this.key}`;
        const response = await fetch(url, {
            method: "GET"
        });
        const jsonResponse = await response.json();
        if (typeof jsonResponse.tags !== "undefined") {
            jsonResponse.tags = new Map(Object.entries(jsonResponse.tags));
        }
        return jsonResponse;
    }
    async getModelSegment(options) {
        const url = `${this.url}models/${options.modelGlobalId}/segments/${options.id}?apiKey=${this.key}`;
        const response = await fetch(url, {
            method: "GET",
            signal: options.signal
        });
        const jsonResponse = await response.json();
        if (typeof jsonResponse.tags !== "undefined") {
            jsonResponse.tags = new Map(Object.entries(jsonResponse.tags));
        }
        if (typeof jsonResponse.forwardTrips !== "undefined") {
            for (const trips of jsonResponse.forwardTrips) {
                for (const location of trips.startLocations) {
                    location.tags = new Map(Object.entries(location.tags));
                }
                for (const location of trips.endLocations) {
                    location.tags = new Map(Object.entries(location.tags));
                }
            }
            for (const trips of jsonResponse.backwardTrips) {
                for (const location of trips.startLocations) {
                    location.tags = new Map(Object.entries(location.tags));
                }
                for (const location of trips.endLocations) {
                    location.tags = new Map(Object.entries(location.tags));
                }
            }
        }
        return jsonResponse;
    }
    async getLocation(id) {
        const url = `${this.url}locations/${id}?apiKey=${this.key}`;
        const response = await fetch(url, {
            method: "GET"
        });
        const jsonResponse = await response.json();
        if (typeof jsonResponse.tags !== "undefined") {
            jsonResponse.tags = new Map(Object.entries(jsonResponse.tags));
        }
        return jsonResponse;
    }
    async getSegment(id) {
        const url = `${this.url}segments/${id}?apiKey=${this.key}`;
        const response = await fetch(url, {
            method: "GET"
        });
        const jsonResponse = await response.json();
        if (typeof jsonResponse.tags !== "undefined") {
            jsonResponse.tags = new Map(Object.entries(jsonResponse.tags));
        }
        if (typeof jsonResponse.forwardTrips !== "undefined") {
            for (const trips of jsonResponse.forwardTrips) {
                for (const location of trips.startLocations) {
                    location.tags = new Map(Object.entries(location.tags));
                }
                for (const location of trips.endLocations) {
                    location.tags = new Map(Object.entries(location.tags));
                }
            }
            for (const trips of jsonResponse.backwardTrips) {
                for (const location of trips.startLocations) {
                    location.tags = new Map(Object.entries(location.tags));
                }
                for (const location of trips.endLocations) {
                    location.tags = new Map(Object.entries(location.tags));
                }
            }
        }
        return jsonResponse;
    }
}
